import axios from "axios";
import { TenderProcedure } from "../../../types/model/procedure/TenderProcedure";
import { SessionStore } from "../../../types/store";
import { newAbortSignal } from "../../../utils";

const BASE_URL = `${process.env.REACT_APP_BACKEND_URL}/app/user/procedures`;

export type ProcedureOrderBy = "ending_soon" | "latest_invited";

interface GetUserInvitedProceduresParams {
  isOpen?: boolean;
  orderBy?: ProcedureOrderBy;
}

export const getUserInvitedProcedures = async ({
  isOpen,
  orderBy,
}: GetUserInvitedProceduresParams = {}): Promise<TenderProcedure[]> => {
  const session: SessionStore | undefined = JSON.parse(
    localStorage.getItem("session") || "{}",
  );

  return await axios
    .get<TenderProcedure[]>(BASE_URL, {
      params: {
        isOpen,
        orderBy,
      },
      headers: {
        "content-type": "application/json",
        "x-access-token": session?.accessToken,
      },
      timeout: Number.parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`),
      signal:
        AbortSignal.timeout === undefined
          ? newAbortSignal(Number(process.env.REACT_APP_AXIOS_TIME_OUT))
          : AbortSignal.timeout(Number(process.env.REACT_APP_AXIOS_TIME_OUT)),
    })
    .then((response) => response.data);
};